import { useEffect, useState } from "react";
import api, { formatPrice } from "../../lib/api";

export default function AdminCustomers() {
    const [customers, setCustomers] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.get("/admin/customers")
            .then(({ data }) => setCustomers(data.customers))
            .finally(() => setLoading(false));
    }, []);

    return (
        <div data-testid="admin-customers">
            <p className="text-[11px] uppercase tracking-[0.4em] text-gold">Atelier</p>
            <h1 className="mt-2 font-display text-4xl text-white">Customers</h1>

            <div className="mt-8 border border-border-dim bg-surface">
                <div className="hidden grid-cols-12 gap-4 border-b border-border-dim px-6 py-4 text-[10px] uppercase tracking-[0.25em] text-white/40 lg:grid">
                    <div className="col-span-4">Name</div>
                    <div className="col-span-4">Email</div>
                    <div className="col-span-2 text-right">Orders</div>
                    <div className="col-span-2 text-right">Spent</div>
                </div>
                {loading ? (
                    <div className="p-6 text-white/40">Loading…</div>
                ) : customers.length === 0 ? (
                    <div className="p-6 text-white/40">No customers yet.</div>
                ) : (
                    customers.map((c) => (
                        <div key={c.id} className="border-b border-border-dim p-4 last:border-b-0 lg:grid lg:grid-cols-12 lg:items-center lg:gap-4 lg:px-6" data-testid={`customer-${c.id}`}>
                            <div className="lg:col-span-4">
                                <p className="text-white">{c.name}</p>
                                <p className="text-xs text-white/40 lg:hidden">{c.email}</p>
                            </div>
                            <div className="hidden text-sm text-white/60 lg:col-span-4 lg:block">{c.email}</div>
                            <div className="mt-2 flex items-center justify-between lg:contents lg:mt-0">
                                <span className="text-xs uppercase tracking-widest text-white/40 lg:hidden">
                                    {c.total_orders} orders
                                </span>
                                <span className="text-gold lg:hidden">{formatPrice(c.total_spent)}</span>
                                <div className="hidden text-right text-white lg:col-span-2 lg:block">{c.total_orders}</div>
                                <div className="hidden text-right text-gold lg:col-span-2 lg:block">{formatPrice(c.total_spent)}</div>
                            </div>
                        </div>
                    ))
                )}
            </div>
        </div>
    );
}
